/* Hover-open behavior for the details-based account/topbar menus
   (announcement bar "My Account" etc. and the header qj-account menu).
   Same grace timing as the main nav: ~300ms to open, ~450ms before closing.
   Click/keyboard toggling still works natively; scrolling closes any open
   menu so nothing is left dangling. Desktop pointer devices only. */
(function () {
  var OPEN_DELAY = 300;
  var CLOSE_DELAY = 450;

  function init() {
    if (!window.matchMedia('(hover: hover) and (min-width: 1025px)').matches) return;

    var menus = Array.prototype.slice.call(
      document.querySelectorAll('.announcement-bar-section header-menu, .section-header header-menu')
    );
    if (!menus.length) return;

    var tracked = [];

    menus.forEach(function (menu) {
      var details = menu.querySelector('details');
      if (!details) return;
      tracked.push(details);
      var timer = null;

      menu.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          details.setAttribute('open', '');
          var summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }, OPEN_DELAY);
      });

      menu.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          details.removeAttribute('open');
          var summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        }, CLOSE_DELAY);
      });
    });

    var scrollTick = false;
    window.addEventListener('scroll', function () {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(function () {
        tracked.forEach(function (details) {
          if (details.hasAttribute('open') && !details.matches(':hover')) {
            details.removeAttribute('open');
            var summary = details.querySelector('summary');
            if (summary) summary.setAttribute('aria-expanded', 'false');
          }
        });
        scrollTick = false;
      });
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
